export default __webpack_public_path__ + "images/6761bfd63218561175ec85c3f5acc273-emoji-angry.svg";